import { ClassActivityPluralTypes } from '../class-activities/types';

const urls = {
  getUnpublishedPolls: (classId: MongoId) =>
    `/ppt-plugin/courses/classes/activities?classId=${classId}&type=${ClassActivityPluralTypes.POLLS}`,
  getPollDetails: ({ pollId, firstAccess }: { pollId: MongoId; firstAccess: NumericBoolean }) =>
    `/polls/get?pollId=${pollId}&firstAccess=${firstAccess}`,
  createPoll: '/polls/create',
  createPollQuestion: '/polls/questions/add',
  updatePoll: '/polls/edit',
  updatePollQuestion: '/polls/questions/edit',
  deletePoll: '/polls/remove',
  savePublishPreferences: '/activities/save/publish-pref',
  publishPoll: '/polls/v4/publish',
  stopPoll: '/polls/stop',
  uploadPollFile: '/geturl/polls/files/upload',
  downloadPollFile: '/polls/files/download',
  setSlideType: '/ppt-plugin/slide-type/set',
  unsetSlideType: '/ppt-plugin/slide-type/unset',
} as const;

export default urls;
